import Api from '../api';
import ENDPOINTS, { ENDPOINTS_SEGMENTS } from '../constants/endpoints';

const getProjectImageRules = (projectId, tenantId) => {
  const params = [];
  if (projectId) params.push(`projectId=${encodeURIComponent(projectId)}`);
  if (tenantId) params.push(`tenantId=${encodeURIComponent(tenantId)}`);
  const query = params.length ? `?${params.join('&')}` : '';
  return Api.get(`${ENDPOINTS.GET_PROJECT_IMAGE_RULES}${query}`);
};

export default {
  getProjectImageRules,
};
